import siteListStore from '@modules/site/site-list-store';
import siteViewStore from '@modules/site/site-view-store';
import siteImporterStore from '@modules/site/site-importer-store';
import siteFormStore from '@modules/site/site-form-store';
import siteDestroyStore from '@modules/site/site-destroy-store';

export default {
  namespaced: true,

  modules: {
    destroy: siteDestroyStore,
    form: siteFormStore,
    list: siteListStore,
    view: siteViewStore,
    importer: siteImporterStore,
  },
};
